import store from "../index";
const state = () => ({
  accountsList: {},
  newsItemsCount: 0,
  currentIndex: 0,
  currentNewsItem: {},
  newsItems: [],
  showNewsDialog: false,
  showSchemeDialog: false,
  selectedCustomersPerNews: [],
  customersList: [
    {
      label: "Test",
      id: 1,
    },
  ],

  // This part is for selecting news items per customer
  salesForceCustomersList: [],
  salesForceCustomersCount: 0,
  currentSalesForceCustomer: {},
  currentCustomersIndex: 0,
  selectedNewsPerCustomer: [{}],
  currentNewsOptions: [],
  selectedNewsForCurrentCustomer: [],
  currentNewsItemPerCustomer: {},
  currentSchemeItemPerCustomer: {},
  showNewsDialogPerCustomer: false,
  newsItemsPerCustomerListForServer: [],

  currentSchemesOptions: [],
  selectedSchemesPerCustomer: [{}],
  selectedSchemesForCurrentCustomer: [],
  schemeItemsPerCustomerListForServer: [],
  schemesItems: [],
  schemesItemsCount: [],
  currentSchemesItem: [],
});

const getters = {};

const actions = {};

const mutations = {
  resetSelectedCustomersPerNews(state) {
    state.selectedCustomersPerNews = [];
  },
  updateCustomersForNewsItem(state, val) {
    state.selectedCustomersPerNews[state.currentIndex].customers = [];
    for (let i = 0; i < val.length; i++) {
      let customer = state.customersList.find((x) => x.id == val[i]);
      state.selectedCustomersPerNews[state.currentIndex].customers.push(
        customer
      );
    }
  },
  enableNewsModal(state) {
    state.showNewsDialog = true;
  },
  disableNewsModal(state) {
    state.showNewsDialog = false;
  },
  enableSchemeModal(state) {
    state.showSchemeDialog = true;
  },
  disableSchemeModal(state) {
    state.showSchemeDialog = false;
  },
  decreaseIndex(state) {
    state.currentIndex = state.currentIndex - 1;
    store.commit("salesForce/updateCurrentNewsItem");
  },
  increaseIndex(state) {
    state.currentIndex = state.currentIndex + 1;
    store.commit("salesForce/updateCurrentNewsItem");
  },
  setIndex(state, val) {
    state.currentIndex = val;
  },

  updateCurrentNewsItem(state) {
    state.currentNewsItem = state.accountsList.newsItems[state.currentIndex];
  },
  setDefaultNewsItem(state) {
    state.currentNewsItem = state.accountsList.newsItems[0];
  },

  updateAccounts(state, data) {
    state.accountsList = data;

    state.salesForceCustomersList = [];
    for (let i = 0; i < state.accountsList.length; i++) {
      state.salesForceCustomersList.push({
        id: state.accountsList[i].id,
        name: state.accountsList[i].name,
      });
    }
    state.salesForceCustomersCount = state.accountsList.length;
  },

  // This part is for selecting news items per customer
  decreaseCustomerIndex(state) {
    state.currentCustomersIndex = state.currentCustomersIndex - 1;
    store.commit("salesForce/updateCurrentCustomerItem");
  },
  increaseCustomerIndex(state) {
    state.currentCustomersIndex = state.currentCustomersIndex + 1;
    store.commit("salesForce/updateCurrentCustomerItem");
  },
  updateCurrentCustomerItem(state) {
    state.currentSalesForceCustomer = {
      id: state.accountsList[state.currentCustomersIndex].id,
      name: state.accountsList[state.currentCustomersIndex].name,
      newsItems: state.accountsList[state.currentCustomersIndex].newsItems,
      schemeItems: state.accountsList[state.currentCustomersIndex].schemeItems,
      customerTags:
        state.accountsList[state.currentCustomersIndex].customerTags,
      contacts: state.accountsList[state.currentCustomersIndex].contacts.map(
        (c) => ({
          fullName: c.fullName,
          email: c.email,
          firstName: c.firstName,
          lastName: c.lastName,
          salesforceId: c.salesforceId,
        })
      ),
    };
    store.commit("salesForce/updateCurrentNewsOptions");
    store.commit("salesForce/updateCurrentSchemesOptions");
  },
  setDefaultCustomerItem(state) {
    state.currentSalesForceCustomer = {
      id: state.accountsList[0].id,
      name: state.accountsList[0].name,
      newsItems: state.accountsList[0].newsItems,
      schemeItems: state.accountsList[0].schemeItems,
      customerTags: state.accountsList[0].customerTags,
    };
    store.commit("salesForce/updateCurrentNewsOptions");
    store.commit("salesForce/updateCurrentSchemesOptions");
  },
  updateCurrentNewsOptions(state) {
    state.currentNewsOptions = [];
    // ADD CHECK IF NEWS IS NOT EMPTY/NULL
    for (let i = 0; i < state.currentSalesForceCustomer.newsItems.length; i++) {
      state.currentNewsOptions.push({
        id: state.currentSalesForceCustomer.newsItems[i].id,
        label: state.currentSalesForceCustomer.newsItems[i].title,
        body: state.currentSalesForceCustomer.newsItems[i].body,
        introduction: state.currentSalesForceCustomer.newsItems[i].introduction,
      });
    }
  },
  updateCurrentSchemesOptions(state) {
    state.currentSchemesOptions = [];
    for (
      let i = 0;
      i < state.currentSalesForceCustomer.schemeItems.length;
      i++
    ) {
      state.currentSchemesOptions.push({
        id: state.currentSalesForceCustomer.schemeItems[i].id,
        label: state.currentSalesForceCustomer.schemeItems[i].title,
        body: state.currentSalesForceCustomer.schemeItems[i].body,
        introduction:
          state.currentSalesForceCustomer.schemeItems[i].introduction,
      });
    }
  },

  resetSelectedNewsPerCustomer(state) {
    state.selectedNewsPerCustomer = [];
    for (let i = 0; i < state.accountsList.length; i++) {
      const c = {
        customerId: state.accountsList[i].id,
        customerName: state.accountsList[i].name,
        news: [],
        contacts: state.accountsList[i].contacts.map((c) => ({
          fullName: c.fullName,
          email: c.email,
          firstName: c.firstName,
          salesforceId: c.salesforceId,
        })),
      };
      state.selectedNewsPerCustomer.push(c);

      for (let j = 0; j < state.accountsList[i].newsItems.length; j++) {
        if (state.accountsList[i].newsItems[j].isSelected)
          c.news.push(state.accountsList[i].newsItems[j]);
      }
    }
  },

  resetSelectedSchemesPerCustomer(state) {
    state.selectedSchemesPerCustomer = [];
    for (let i = 0; i < state.accountsList.length; i++) {
      const c = {
        customerId: state.accountsList[i].id,
        customerName: state.accountsList[i].name,
        schemes: [],
        contacts: state.accountsList[i].contacts.map((c) => ({
          fullName: c.fullName,
          email: c.email,
          firstName: c.firstName,
          salesforceId: c.salesforceId,
        })),
      };
      state.selectedSchemesPerCustomer.push(c);

      for (let j = 0; j < state.accountsList[i].schemeItems.length; j++) {
        if (state.accountsList[i].schemeItems[j].isSelected)
          c.schemes.push(state.accountsList[i].schemeItems[j]);
      }
    }
  },

  createNewsItemsPerCustomerListForServer(state) {
    state.newsItemsPerCustomerListForServer = [];
    for (let i = 0; i < state.selectedNewsPerCustomer.length; i++) {
      state.newsItemsPerCustomerListForServer.push({
        customerId: state.selectedNewsPerCustomer[i].customerId,
        selectedIds: state.selectedNewsPerCustomer[i].news.map((x) => x.id),
        contacts: state.selectedNewsPerCustomer[i].contacts.map((c) => ({
          fullName: c.fullName,
          email: c.email,
          name: c.name,
          firstName: c.firstName,
          salesforceId: c.salesforceId,
        })),
      });
    }
  },

  createSchemeItemsPerCustomerListForServer(state) {
    state.schemeItemsPerCustomerListForServer = [];
    for (let i = 0; i < state.selectedSchemesPerCustomer.length; i++) {
      state.schemeItemsPerCustomerListForServer.push({
        customerId: state.selectedSchemesPerCustomer[i].customerId,
        selectedIds: state.selectedSchemesPerCustomer[i].schemes.map(
          (x) => x.id
        ),
        contacts: state.selectedSchemesPerCustomer[i].contacts.map((c) => ({
          fullName: c.fullName,
          email: c.email,
          name: c.name,
          firstName: c.firstName,
          salesforceId: c.salesforceId,
        })),
      });
    }
  },

  updateNewsForCustomer(state, val) {
    state.selectedNewsPerCustomer[state.currentCustomersIndex] = {
      customerId: state.accountsList[state.currentCustomersIndex].id,
      customerName: state.accountsList[state.currentCustomersIndex].name,
      news: [],
      contacts: state.accountsList[state.currentCustomersIndex].contacts.map(
        (c) => ({
          fullName: c.fullName,
          email: c.email,
          firstName: c.firstName,
          salesforceId: c.salesforceId,
        })
      ),
    };

    for (let i = 0; i < val.length; i++) {
      let news = state.currentNewsOptions.find((x) => x.id == val[i]);
      state.selectedNewsPerCustomer[state.currentCustomersIndex].news.push(
        news
      );
    }
  },

  updateSchemesForCustomer(state, val) {
    state.selectedSchemesPerCustomer[state.currentCustomersIndex] = {
      customerId: state.accountsList[state.currentCustomersIndex].id,
      customerName: state.accountsList[state.currentCustomersIndex].name,
      schemes: [],
      contacts: state.accountsList[state.currentCustomersIndex].contacts.map(
        (c) => ({
          fullName: c.fullName,
          email: c.email,
          firstName: c.firstName,
          salesforceId: c.salesforceId,
        })
      ),
    };
    for (let i = 0; i < val.length; i++) {
      let schemes = state.currentSchemesOptions.find((x) => x.id == val[i]);
      state.selectedSchemesPerCustomer[
        state.currentCustomersIndex
      ].schemes.push(schemes);
    }
  },

  updateNewsForCurrentCustomer(state) {
    state.selectedNewsForCurrentCustomer = [];
    var arr = state.selectedNewsPerCustomer[state.currentCustomersIndex];
    if (arr && arr.news.length > 0)
      for (let i = 0; i < arr.news.length; i++) {
        state.selectedNewsForCurrentCustomer.push(arr.news[i].id);
      }
  },

  updateSchemesForCurrentCustomer(state) {
    state.selectedSchemesForCurrentCustomer = [];
    var arr = state.selectedSchemesPerCustomer[state.currentCustomersIndex];
    if (arr && arr.schemes.length > 0)
      for (let i = 0; i < arr.schemes.length; i++) {
        state.selectedSchemesForCurrentCustomer.push(arr.schemes[i].id);
      }
  },

  setCustomersIndex(state, val) {
    state.currentCustomersIndex = val;
  },

  updateCurrentNewsItemPerCustomer(state, id) {
    state.currentNewsItemPerCustomer = state.currentNewsOptions.find(
      (x) => x.id == id
    );
  },

  updateCurrentSchemeItemPerCustomer(state, id) {
    state.currentSchemeItemPerCustomer = state.currentSchemesOptions.find(
      (x) => x.id == id
    );
  },

  enableNewsModalPerCustomer(state) {
    state.showNewsDialogPerCustomer = true;
  },

  disableNewsModalPerCustomer(state) {
    state.showNewsDialogPerCustomer = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
